// extracted by mini-css-extract-plugin
module.exports = {"container":"EarlyDocumentsBadge_container__owllP"};